import { Component } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { User } from '../../models/User';
import { firstValueFrom } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

import { ModalService } from '../../services/modal.service';
import { DeleteAccountModalComponent } from '../modales/delete-account-modal/delete-account-modal.component';
import { StorageService } from '../../services/storage.service';
import { TranslateModule } from '@ngx-translate/core';
import { TranslationService } from '../../services/translation.service';
import { LanguageConfig } from '../../models/Translation';
import { Router } from '@angular/router';

@Component({
  selector: 'app-settings',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './settings.component.html',
  styleUrl: './settings.component.scss',
})
export class SettingsComponent {
  user?: User = undefined;
  currentLanguage: LanguageConfig;
  isGarUser: boolean = false;

  constructor(
    private router: Router,
    private toaster: ToastrService,
    private authService: AuthService,
    private modalService: ModalService,
    private storageService: StorageService,
    private translationService: TranslationService,
  ) {
    this.currentLanguage = this.translationService.getCurrentLanguageConfig();
  }

  async ngOnInit() {
    try {
      let user = await firstValueFrom(this.authService.getUserInfoOrRefreshIfNeeded());
      this.user = user;
      this.isGarUser = Boolean(user.gar_ido);
    } catch {
      const errorMessage = this.translationService.instant('errors.network.serverError');
      this.toaster.error(errorMessage);
    }
  }

  async setTheme(newValue: string) {
    try {
      let newUser = await firstValueFrom(this.authService.updateMyUser(this.user?.id ?? '', newValue, undefined, undefined));

      this.user = newUser;
      if (newUser.graphism == newValue) {
        const successMessage = this.translationService.instant('common.messages.operationSuccess');
        this.toaster.success(successMessage);
      }
    } catch {
      const errorMessage = this.translationService.instant('errors.network.serverError');
      this.toaster.error(errorMessage);
    }
  }

  logout() {
    const text = this.translationService.instant('settings.account.logout');

    if (confirm(text)) {
      this.authService.logout();
    }
  }

  async deleteAccount() {
    const modalRef = this.modalService.open(DeleteAccountModalComponent, {
      size: 'lg',
      backdrop: 'static',
      keyboard: false,
    });

    modalRef.result.then((result) => {
      if (result === 'cancel') {
        // ici
      }
    });
  }

  isActive(str: string): boolean {
    return this.user?.graphism === str;
  }

  shouldDisplayDelete(): boolean {
    return this.user?.is_parent === true;
  }

  shouldDisplayCGU(): boolean {
    return this.user?.is_parent === true && !this.isGarUser;
  }

  shouldDisplayGarLegal(): boolean {
    return this.isGarUser;
  }

  shouldDisplayLogout(): boolean {
    return !this.isGarUser;
  }

  loadPdf(pdf: string) {
    if (this.storageService.getMobile()) {
      confirm(`${window.location.origin}${pdf}`);
    } else {
      window.open(pdf, '_blank');
    }
  }

  updateAvatar() {
    this.router.navigate(['/update_avatar']);
  }
}
